import React from 'react'
import { MergeTag } from '@ninetailed/experience.js-react'

interface NinetailedMergeTagProps {
  id: string
  fallback: string
}

export const NinetailedMergeTag: React.FC<NinetailedMergeTagProps> = ({ id, fallback }) => {
  return <MergeTag id={id} fallback={fallback} />
}
